// extracted by mini-css-extract-plugin
module.exports = {"invoice-table":"InvoicesTable_invoice-table__2nO5H","invoices-body":"InvoicesTable_invoices-body__3q1C6"};